import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Helpers } from '../helpers';
import { Paths } from '../models/enums';
import { Router, RouterStateSnapshot } from '@angular/router';
@Injectable()
export class DataService {
    private profileSubject = new BehaviorSubject<any>({} as any);
    private authDataPrefix = 'zone_authData_';
    private userDataPrefix = 'zone_user_';
    private router: Router;

    public profile = this.profileSubject
        .asObservable()
        .pipe(distinctUntilChanged());

    public publisherId: string;
    public path: string;
    public apiEndpoint: string;
    public token: string;
    public roles: string[] = [];

    constructor() {
        this.path = Helpers.getPath();
        if (this.path == '') this.path = Paths.Publisher;
        this.apiEndpoint = Helpers.getApiEndpoint();
        this.token = Helpers.getAccessToken();
        const user = this.getUser();
        if (user) {
            this.profileSubject.next(user);
        }
        this.profile.subscribe(user => {
            if (!user || (this.path == Paths.Publisher && !user.userGroup)) {
                this.removeAuthData();
                return;
            }
            this.publisherId = user.publisherId;
            if (user.userGroup) {
                this.roles = user.userGroup.userGroupRoles.map(u => u.role.key);
            }
        });
    }

    getUser() {
        return this.getLocalStorageUser();
    }

    setUser(user = {}) {
        this.setLocalStorageUser(user);
        this.profileSubject.next(user);
    }

    setAuthData(authData) {
        localStorage.setItem(
            this.authDataPrefix + this.path,
            JSON.stringify(authData)
        );
    }

    getAuthData() {
        var authData = JSON.parse(
            localStorage.getItem(this.authDataPrefix + this.path)
        );
        return authData;
    }

    removeAuthData() {
        localStorage.removeItem(this.authDataPrefix + this.path);
        this.removeLocalStorageUser();
    }

    private setLocalStorageUser(user) {
        localStorage.setItem(this.userDataPrefix + this.path, JSON.stringify(user));
    }

    private getLocalStorageUser() {
        return JSON.parse(localStorage.getItem(this.userDataPrefix + this.path));
    }

    private removeLocalStorageUser() {
        localStorage.removeItem(this.userDataPrefix + this.path);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/data.service.ts